import { useState, useEffect } from 'react';
import { Form, Image } from 'react-bootstrap';
import { updateProfile, updatePassword } from 'firebase/auth';
import { ReactComponent as SaveImage } from '../../public/images/svg/ImageSave.svg';
import { ReactComponent as DefaultUser } from '../../public/icons/user-default.svg';
import defaultUserUrl from '../../public/icons/user-default.svg';
import { auth } from '../Services/firebase';
import GlyphButton from '../Controls/Button/GlyphButton';
import './css/AccountProfile.css';


export function AccountProfile({ onSuccess }: {
    onSuccess: (name: string) => void;
}) {
    const user = auth.currentUser;
    const [displayName, setDisplayName] = useState(user?.displayName || '');
    const [photoURL, setPhotoURL] = useState(user?.photoURL || '');
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (user) {
            setDisplayName(user.displayName || '');
            setPhotoURL(user.photoURL || '');
        }
    }, [user]);

    const handleUpdate = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            if (user) {
                await updateProfile(user, { displayName, photoURL });
                onSuccess(auth.currentUser?.displayName || 'Skitterbooker');
            }
        } catch (err: unknown) {
            if (err instanceof Error) {
                setError(err.message);
            } else {
                setError('Unexpected error occurred.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>{user && <Form onSubmit={handleUpdate}>
            <div className="profile-container">
                <div className="profile-container-left">
                    <div className="profile-field-container">
                        <div className="profile-field">
                            <Form.Group controlId="formDisplayName">
                                <Form.Label>Display Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={displayName}
                                    onChange={(e) => setDisplayName(e.target.value)}
                                    placeholder="Your display name"
                                />
                            </Form.Group>
                        </div>
                    </div>
                    <div className="profile-control">
                        <GlyphButton ariaLabel="save-profile" disabled={loading} IconComponent={<SaveImage height={32} width={32} viewBox="0 0 32 32" />}>
                            {loading ? 'Saving…' : 'Update Profile'}
                        </GlyphButton>
                    </div>
                </div>
                <div className="profile-container-right">
                    <div className="profile-account-image">
                        <img
                            src={photoURL || defaultUserUrl}
                            width={80}
                            height={80}
                            alt="Profile avatar" />
                    </div>
                </div>
            </div>

            {error && <div className="text-danger mb-2">{error}</div>}
        </Form >}

        </div>
    );
}
